﻿//validate

(function ($) {
 
    var sform = $("#contact-form-section");
    var formContainer = $("#contact-form-section .container");
    var formBtn = $("#contact-form-section .btn");
    var myStyle = "<style>.form-messages * { color:white; list-style:none;} </style>";
    formContainer.append("<div class='form-messages'> " + myStyle + "</div>");

    formBtn.on("click", validateForm);
    savePlaceHolders("#contact-form-section");

    function savePlaceHolders(form) {
        $(form).find("input").each(function () {
            $(this).attr("data-holder", $(this).attr("placeholder"));
        });
        resetInputs(form);
    }

    function resetInputs(form) {
        $(form).find("input,textarea").each(function ()
        {
            $(this).val("");
            $(this).attr("placeholder", $(this).attr("data-holder"));
        });
    }

    function validateForm(e)
    {
        // edit this function URL
        e.preventDefault();
        formContainer.removeClass("shakeme");
        formContainer.find(".form-messages").html(myStyle);
        $("#loader").fadeIn();
        var ul = "<ul>";
        var li = "";
        var isValid = false;
        var name = formContainer.find(".input-name");
        var mail = formContainer.find(".input-email");
        var phone = formContainer.find(".input-phone");
        var message = formContainer.find("textarea");
        var privacyCheckbox = formContainer.find("#privacyCheckbox");
        var privacyErr = formContainer.find("#privacyErr");
        
        var nameMessage, mailMessage, phoneMessagel;
        var phoneReg = new RegExp(/^[\d\-]+$/);
        var mailReg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        var succes = 0;
        if ($("body").hasClass("heb")) {
            nameMessage = "אנא הכנס שם תקין";
            mailMessage = "אנא הכנס כתובת דואר אלקטרונית תקינה";
            phoneMessagel = "אנא הכנס מספר טלפון תקין";
        }
        else {
            nameMessage = "Please Enter a valid name";
            mailMessage = "Please Enter a valid mail";
            phoneMessagel = "Please Enter a valid phone";
        }

        name.removeClass("err");
        phone.removeClass("err");
        mail.removeClass("err");
        if (name.val() != "" && name.val() != null) {
            succes++;
        }
        else {
            name.val("");
            name.attr("placeholder", nameMessage);
            name.addClass("err");
            li += "<li> " + nameMessage + "</li>";

        }

        if (mail.val() != "" && mail.val() != null && mailReg.test(mail.val())) {
            succes++;
        }
        else {
            mail.val("");
            mail.addClass("err");
            mail.attr("placeholder", mailMessage);
            li += "<li>" + mailMessage + " </li>";

        }
        if (phone.val().length >= 9 && phone.val() != "" && phone.val() != null && phoneReg.test(phone.val())) {
            succes++;
        }
        else {
            phone.val("");
            phone.addClass("err");
            phone.attr("placeholder", phoneMessagel);
            li += "<li> " + phoneMessagel + "</li>";

        }

        if (privacyCheckbox.is(":checked") == true) {
            succes++;
            privacyErr.css("visibility", "hidden");
        }
        else {
            privacyErr.css("visibility", "visible");
        }

        if (succes == 4) {
            isValid = true;
        }
        if (isValid) {
            ContactUs(name.val(), mail.val(), phone.val(), message.val());
        }
        else {
            ul += li + "</ul>";
            //formContainer.find(".form-messages").append(ul);
            $("#loader").fadeOut();
            formContainer.addClass("shakeme");
        }
        setTimeout(function () {
            formContainer.removeClass("shakeme");
        }, 1000);

    }

    function ContactUs(name, mail, phone, message) {
        grecaptcha.ready(function () {
            grecaptcha.execute(AppSettings.reCaptchaSiteKey, { action: 'submit' }).then(function (token) {
                var data = {
                    Name: name,
                    Email: mail,
                    Phone: phone,
                    Message: message,
                    recaptchaToken: token
                };
                var sUrl = "/Shared/MainFormContact";
                $.ajax({
                    url: sUrl,
                    type: 'POST',
                    contentType: "application/json",
                    data: JSON.stringify({ contact: data }),
                    success: function (data) {
                        console.log(data);
                        $("#loader").fadeOut();
                        $("#async-message").fadeIn();
                        resetInputs(sform);
                        setTimeout(function () {
                            $("#async-message").fadeOut();
                            dataLayer.push({ 'event': 'virtualPageview', 'virtualPageURL': '/thank-you', 'virtualPageTitle': 'תודה על השארת פרטים' });

                        }, 5 * 1000);
                    },
                    error: function (x, h, r) {
                        console.log('error');
                        $("#loader").fadeOut();
                        $("#async-message").fadeIn();
                        resetInputs(sform);
                        $(".err-msg").fadeIn();
                        setTimeout(function () {
                            $(".err-msg").fadeOut();
                        }, 5 * 1000);
                    }
                });
            });
        });
    }

})(jQuery);




//////////////////
// WEBPACK FOOTER
// ../scripts/yit/form.js
// module id = 2
// module chunks = 0